import { useState } from 'react';
import { Modal, notification, Pagination } from 'antd';

import { Button, DotBtn } from 'components';
import { useHooks, useDebounce, usePost } from 'hooks';
import Container from 'modules/container';
import Fields from 'components/fields';
import UpdateTestimonials from './update';

const Testimonials = () => {
  const { t, qs, get, location, queryClient } = useHooks();
  const { mutate } = usePost();
  const [page, setPage] = useState<number>(1);
  const [query, setQuery] = useState('');
  const searchQuery = useDebounce(query, 600);
  const [createTestimonials, openCreateTestimonials] = useState<any>({
    data: null,
    open: false,
  });

  const params = qs.parse(location.search, { ignoreQueryPrefix: true });

  const onDeleteHandlerTestimonials = (row: any) => {
    const id = get(row, '_id');
    Modal.confirm({
      title: t("Izohni o'chirishni tasdiqlaysizmi") + '?',
      cancelText: t("yo'q"),
      okType: 'primary',
      okText: t('ha'),
      onOk: () => deleteActionTestimonials(id),
    });
  };

  const deleteActionTestimonials = (id: any) => {
    if (id) {
      mutate(
        { method: 'delete', url: `testimonials/${id}`, data: null },
        {
          onSuccess: () => {
            queryClient.invalidateQueries({
              queryKey: [`testimonials`],
            });
            notification['success']({
              message: t('Успешно удален!'),
              duration: 2,
            });
          },
          onError: (error: any) => {
            notification['error']({
              message: t(
                get(error, 'response.data.error', 'Произошло ошибка!')
              ),
              duration: get(error, 'response.data.message') ? 4 : 2,
            });
          },
        }
      );
    }
  };

  return (
    <>
      <Modal
        open={get(createTestimonials, 'open')}
        onOk={() => openCreateTestimonials({ open: true, data: null })}
        onCancel={() => openCreateTestimonials({ open: false, data: null })}
        footer={null}
        centered
        title={
          get(createTestimonials, 'data')
            ? t('Izohni tahrirlash')
            : t("Izoh qo'shish")
        }
        width={600}
        destroyOnClose
      >
        <UpdateTestimonials {...{ createTestimonials, openCreateTestimonials }} />
      </Modal>
      <div className="content-panel">
        <div>
          <Container.All
            url="testimonials"
            name="testimonials"
            params={{
              limit: 15,
              page,
              extra: {
                search: searchQuery,
                start: params.start && params.start,
                end: params.end && params.end,
              },
            }}
          >
            {({ meta, items }) => {
              return (
                <div>
                  <div className="page-heading">
                    <p className="page-heading__title">
                      {t('Izohlar')}
                      <p className="page-heading__subtitle">
                        {t('Izohlar soni')}: {get(meta, 'totalCount')}
                      </p>
                    </p>
                    <div className="page-heading__right">
                      <Button
                        type="primary"
                        title="Qo'shish"
                        create
                        onClick={() =>
                          openCreateTestimonials({ open: true, data: null })
                        }
                      />
                    </div>
                  </div>
                  <div className="flex flex-wrap justify-items-start gap-5">
                    {items.map((item: any, index: number) => (
                      <div key={index} className="w-[24%] h-full relative">
                        <h3>{item.fullName}</h3>
                        <p>{item.company}, {item.position}</p>
                        <img
                          className="w-full h-[200px] max-w-[400px] min-w-[200px] object-fill"
                          src={String(item.image?.url)}
                          alt=""
                        />
                        <div className="absolute top-2 right-2">
                          <DotBtn
                            row={item}
                            editFunction={() =>
                              openCreateTestimonials({ open: true, data: item })
                            }
                            deleteFunction={() => onDeleteHandlerTestimonials(item)}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                  {meta && meta.perPage && (
                    <div className="pt-[20px] flex justify-end">
                      <Pagination
                        current={meta.currentPage}
                        pageSize={meta.perPage}
                        total={meta.totalCount}
                        onChange={setPage}
                      />
                    </div>
                  )}
                </div>
              );
            }}
          </Container.All>
        </div>
      </div>
    </>
  );
};

export default Testimonials;
